module.exports = __webpack_public_path__ + "static/daerns_instant_fortress-d2ce4f5cf93757732bdf6f5d72e25056.jpeg";